import React from 'react';
import BannersComponent from '../components/banners';

const BannersPage = () => {

	return (
		<div>
			<BannersComponent />
		</div>
	)

}

export default BannersPage;


// WEBPACK FOOTER //
// ./src/containers/banners-page.js